import React from 'react';
import { EyeIcon, ClockIcon, BadgeCheck } from 'lucide-react';
const HeaderGlpPlateau4 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-7515">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-7516"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-7517">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-7518">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-7519">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-7520">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-7521">
          <div className="text-left" data-id="element-7522">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-7523">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-7524">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-7525">
        <div className="max-w-4xl mx-auto" data-id="element-7526">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-7527">
            GLP-1 NEWS
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-7528">
            The "Metabolic Panic" Response: Why GLP-1 Users Plateau (And How To Break Through)


          </h1>
          <p className="text-sm sm:text-base text-gray-500 italic mb-6" data-id="element-7529">
            (From a Metabolic Specialist Who Spent 18 Months Trying To Solve Her
            Own Plateau)
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-gray-200" data-id="element-7530">
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-7531">
              <img src="https://cdn.magicpatterns.com/uploads/njKHWtEUNXzL7WtDqVKiu5/pasted-image.jpg" alt="Dr. Patricia Reed" className="w-full h-full object-cover" data-id="element-7532" />
            </div>
            <div className="flex-1" data-id="element-7533">
              <div className="flex items-center gap-2 mb-2" data-id="element-7534">
                <span className="text-base font-medium text-gray-900" data-id="element-7535">
                  Written by Dr. Patricia Reed
                </span>
                <BadgeCheck className="h-5 w-5 text-blue-600" data-id="element-7536" />
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-7537">
                Verified Metabolic Health Specialist, Cedar Sinai Medical Center
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-7538">
                <div className="flex items-center gap-1" data-id="element-7539">
                  <ClockIcon className="h-4 w-4" data-id="element-7540" />
                  <span data-id="element-7541">7 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-7542">
                  <EyeIcon className="h-4 w-4" data-id="element-7543" />
                  <span data-id="element-7544">171,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-7545">
            <img src="https://cdn.magicpatterns.com/uploads/nwn6hondxNojcsAjvGQfEj/2.png" alt="Before and after transformation" className="w-full rounded-lg shadow-lg mb-3" data-id="element-7546" />
            <div className="flex justify-between items-center px-2 py-1 bg-gray-50 rounded border-t border-gray-200" data-id="element-7547">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-7548">
                September 25, 2021
              </span>
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-7549">
                December 7, 2025
              </span>
            </div>
          </div>

          <div className="mb-6" data-id="element-7550"></div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-7551">
            Before you increase your dose, read this. If the scale has stopped
            moving, your body hasn't built a tolerance — it has hit a "stress
            threshold." Here's how to break through it, or prevent it from ever
            happening.
          </p>

          <div className="border-t border-gray-200 pt-3 mb-6 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-7552">
            <div className="mb-1 flex items-center" data-id="element-7553">
              <span className="font-medium mr-2" data-id="element-7554">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-7555">
              <span className="font-medium mr-2" data-id="element-7556">Published:</span>
              January 2026
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpPlateau4;